<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
}>();

const iconStyle = computed(() => {
  if (typeof props.size === 'number') {
    return { fontSize: `${props.size}px` };
  }
  
  const sizeMap = {
    'xs': '16px',
    'sm': '20px',
    'md': '24px',
    'lg': '32px',
    'xl': '48px'
  };
  
  return { fontSize: sizeMap[props.size as keyof typeof sizeMap] || '24px' };
});
</script>

<template>
  <span class="material-symbols-outlined" :style="iconStyle">
    <slot></slot>
  </span>
</template>

<style scoped>
.material-symbols-outlined {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 1;
}
</style>
